import { observer } from 'mobx-react-lite'
import {
  formatBookkeepingAccessMethod,
  formatBookkeepingManagerAction,
} from '@/features/admin/bookkeeping/bookkeeping-pending-action-formatters'
import { type BookkeepingPendingActionItemViewModel } from '@/features/admin/bookkeeping/BookkeepingPendingActionItemViewModel'
import { type ColumnId } from '@/features/admin/bookkeeping/bookkeeping-manager-table-columns'
import { BookkeepingManagerTableRow } from '@/features/admin/bookkeeping/components/BookkeepingManagerTableRow'
import { Member } from '@/features/iam/members/Member'

export interface BookkeepingManagerTableRowContainerProps {
  vm: BookkeepingPendingActionItemViewModel
  columnIds: ColumnId[]
}

export const BookkeepingManagerTableRowContainer = observer(
  function BookkeepingManagerTableRowContainer({
    vm,
    columnIds,
  }: BookkeepingManagerTableRowContainerProps) {
    const bookkeepingPendingAction = vm.bookkeepingPendingAction
    const championPro = bookkeepingPendingAction.championPro
    return (
      <BookkeepingManagerTableRow
        id={bookkeepingPendingAction.id}
        columnIds={columnIds}
        isActive={vm.isActive}
        onPress={vm.select}
        jobShortId={bookkeepingPendingAction.jobShortId}
        customerDisplayName={bookkeepingPendingAction.customer.displayName}
        customerAvatar={bookkeepingPendingAction.customer.avatar}
        jobName={bookkeepingPendingAction.jobName}
        companyName={bookkeepingPendingAction.platformConnection?.displayName}
        championPro={
          championPro === Member.none
            ? null
            : {
                displayName: championPro.displayName,
                avatar: championPro.avatar,
              }
        }
        proEmail={championPro.email}
        displayAccessMethod={formatBookkeepingAccessMethod(
          bookkeepingPendingAction.accessMethod,
        )}
        displayAction={formatBookkeepingManagerAction(
          bookkeepingPendingAction.action,
        )}
        datePendingSince={bookkeepingPendingAction.datePendingSince}
      />
    )
  },
)
